import { renameFile } from "../../api/uploadService";

export const useRenameFile = (successCallback) => {
    const rename = async (id, data) => {
        try {
            const updatedRecord = await renameFile(id, data);
            successCallback(updatedRecord);
            return updatedRecord;
        } catch (error) {
            console.error("Failed to rename file:", error);
            throw error;
        }
    };

  return { rename };
};